import React from "react";
import monitor from "@common/assets/images/icons/monitor.svg";
import caseicon from "@common/assets/images/icons/case.svg";
import notebook from "@common/assets/images/icons/notebook-square.svg";
import leaf from "@common/assets/images/icons/leaf-2.svg";
import social from "@common/assets/images/icons/social.svg";


const CsrMission = () => {
  const missionItems = [
    {
      icon: notebook,
      title: "Creating Conducive Learning Environments",
      description: "We develop and enhance educational infrastructure to nurture the future leaders of our communities. By building safe, inspiring and well-equipped spaces, we ensure that every child has the opportunity to thrive in a supportive learning environment.",
      alt: "Learning Environment Icon"
    },
    {
      icon: social,
      title: "Promoting Physical and Social Development",
      description: "With access to quality sports equipment and playgrounds, we encourage physical activity, teamwork, and social interaction as vital elements of a child's holistic development.",
      alt: "Physical Development Icon"
    },
    {
      icon: leaf,
      title: "Ensuring Access to Essential Amenities",
      description: "Equipping schools with clean water access, proper sanitation, and secure infrastructure, creating a healthy, safe, and respectful environment for children to learn and grow.",
      alt: "Essential Amenities Icon"
    },
    {
      icon: caseicon,
      title: "Supporting Families by Providing School Essentials",
      description: "We help reduce the financial burden on families by supplying essentials such as school uniforms, bags, umbrellas and learning essentials. This not only promotes regular attendance but also contributes to the overall well-being of the entire family.",
      alt: "Family Support Icon"
    },
    {
      icon: monitor,
      title: "Enhancing Learning Through Technology",
      description: "With the introduction of smart TVs and computers, we are modernizing the classroom experience.",
      alt: "Technology Icon"
    }
  ];

  return (
    <div className="bs-section bs-section--typ-csr-mission">
      <div className="bs-section__section-cont">
        <div className="bs-csr-mission-layout">
          {/* Header */}
          <div className="bs-csr-mission-layout__header">
            <p className="bs-csr-mission-layout__label">OUR MISSION</p>
            <h2 className="bs-csr-mission-layout__title">
              CREATING A BETTER
              <br />
              TOMORROW, TODAY
            </h2>
          </div>

          {/* Mission Grid */}
          <div className="bs-csr-mission-layout__grid">
            {missionItems.map((item, index) => (
              <div key={index} className="bs-csr-mission-layout__item">
                <div className="bs-csr-mission-layout__icon">
                  <img
                    src={item.icon}
                    alt={item.alt}
                    className="bs-csr-mission-layout__icon-img"
                  />
                </div>
                <h3 className="bs-csr-mission-layout__item-title">
                  {item.title}
                </h3>
                <p className="bs-csr-mission-layout__item-description">
                  {item.description}
                </p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default CsrMission;